import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { SenderRegistration as SENDER_ADD } from 'Components/Api/EpocketDMTApi';
import { SelectBank as BANK_SELECT } from 'Components/Api/EpocketDMTApi';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const SenderAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [bankList, setBankList] = useState([]);

    const location = useLocation();
    const Mobile = location.state.Mobile;

    const bankDefault = {
        Name: 'Select Bank',
        DefaultIFSC: ''
    };
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        AccountNo: '',
        BeneName: '',
        Bank: bankDefault,
        IFSC: ''
    });
    const selectBank = async () => {
        setLoading(true);
        const response = await BANK_SELECT();
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        var request = {
            Name: values.Name,
            BankName: values.Bank.Name,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            Mobile: values.Mobile,
            BeneName: values.BeneName
        };

        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await SENDER_ADD(requestObj);
        setLoading(false);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        setIsError(true);

        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setSeverity('error');
            setLoading(false);
            return;
        }
        resetForm(formObject);

        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);

        var paramSender = {
            Mobile: values.Mobile,
            SenderID: data.SenderID,
            BeneficiaryID: data.BeneficiaryID
        };

        history.push('/EDMT/Sender/Verify/', paramSender);
    };

    const select = () => {
        setFormObject({
            ...formObject,
            Mobile: Mobile,
            Name: ''
        });
    };

    useEffect(() => {
        selectBank();
        select();
    }, []);

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        Name: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'Sender Name')
            .min(8, PLEASE_PROVIDE_VALID + 'at least 8 length sender name'),
        Bank: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'bank')
            .required(PLEASE_SELECT_VALID + 'bank')
            .shape({
                Name: Yup.string()
                    .notOneOf([bankDefault.Name], PLEASE_SELECT_VALID + 'bank')
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank')
            }),
        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),
        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),
        BeneName: Yup.string().required(PLEASE_PROVIDE_VALID + 'Bene Name')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>Sender Add</h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialNumberField
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                readOnly={true}
                                                placeholder="Mobile"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Sender Name"
                                                name="Name"
                                                type="text"
                                                placeholder="Sender Name"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialNumberField
                                                label="Account No."
                                                name="AccountNo"
                                                type="text"
                                                length={20}
                                                placeholder="Account No."
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Bene Name"
                                                name="BeneName"
                                                type="text"
                                                placeholder="Bene Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <Field
                                                component={AutoCompleteTextView}
                                                defaultValue={bankDefault}
                                                SubFieldName="Name"
                                                FieldName="Bank"
                                                name="Bank"
                                                options={bankList}
                                                getOptionLabel={(option) =>
                                                    option.Name
                                                }
                                                getOptionSelected={(
                                                    option,
                                                    value
                                                ) => option.Name === value.Name}
                                                textFieldProps={{
                                                    label: 'Bank'
                                                }}
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    setFieldValue(
                                                        'IFSC',
                                                        value.DefaultIFSC
                                                    );
                                                }}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="IFSC"
                                                name="IFSC"
                                                type="text"
                                                length={11}
                                                placeholder="IFSC"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Add"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loading}
                                        >
                                            Add
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
